/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { HomeRisk } from './homeRisk';
import { Invoice } from './invoice';
import { Participant } from './participant';
import { PartnershipCard } from './partnershipCard';
import { PaymentMethod } from './paymentMethod';
import { PolicyDocument } from './policyDocument';
import { PremiumDetail } from './premiumDetail';
import { PremiumDiscount } from './premiumDiscount';
import { PremiumPaymentModality } from './premiumPaymentModality';

export interface HomePolicy {
  /**
   * Numerical reference that MAPFRE assigns to each project to identify it
   */
  projectQuoteId?: string;
  /**
   * Numerical reference that MAPFRE assigns to each insurance contract to identify it
   */
  policyId?: string;
  /**
   * Numerical reference that MAPFRE gives to client to identify his policy
   */
  policyNumber?: string;
  /**
   * policy status code
   */
  policyStatusCode?: string;
  /**
   * Identifier of the Branch or line of bussines
   */
  branchCode?: string;
  /**
   * Branch description
   */
  readonly branchDesc?: string;
  /**
   * Indicates the policy sector code
   */
  sectorCode?: HomePolicy.SectorCodeEnum;
  /**
   * Indicates the policy sector description
   */
  sectorDesc?: string;
  /**
   * Identifier of the company owns the final contract
   */
  companyId?: string;
  effectiveDate?: Date;
  captureDate?: Date;
  cancellationDate?: Date;
  /**
   * UserId associated with the project
   */
  userId?: string;
  /**
   * Identification of the action. The names of the shares by entity will be typified and indicated in the list of the entity's own shares
   */
  actionId?: string;
  premiumPaymentModality?: PremiumPaymentModality;
  premiumDetail?: PremiumDetail;
  premiumDiscount?: PremiumDiscount;
  /**
   * Participant list
   */
  policyParticipants?: Array<Participant>;
  /**
   * Risks list
   */
  homeRisks?: Array<HomeRisk>;
  /**
   * Date in which the policy is expired
   */
  expirationDate?: Date;
  status?: HomePolicy.StatusEnum;
  partnershipCard?: Array<PartnershipCard>;
  /**
   * Flag that indicates if it has a policy
   */
  policyExistsInd?: boolean;
  installmentInvoices?: Array<Invoice>;
  messagePolicyId?: string;
  messagePaymentId?: string;
  paymentMethod?: PaymentMethod;
  mip?: HomePolicy.MipEnum;
  policyDocument?: Array<PolicyDocument>;
  recurringPayment?: boolean;
  actions?: Array<HomePolicy.ActionsEnum>;
  policyVersion?: string;
  dueDateClaim?: Date;
  coverageEndDateClaim?: Date;
  rateFromDate?: Date;
}
export namespace HomePolicy {
  export type SectorCodeEnum = 'HomePRHLine' | 'PMILine';
  export const SectorCodeEnum = {
    HomePRHLine: 'HomePRHLine' as SectorCodeEnum,
    PMILine: 'PMILine' as SectorCodeEnum,
  };
  export type StatusEnum =
    | 'VALIDO'
    | 'SCADUTO'
    | 'NON_VALIDO'
    | 'SCADUTO_DECORRENZA'
    | 'DECORRENZA_POST_60_GIORNI'
    | 'NON_VALIDO_SELLA'
    | 'APPENDICE'
    | 'ACQUISTATO'
    | 'SCADUTA'
    | 'ACQUISTATA'
    | 'ATTIVA'
    | 'CANCELLATA'
    | 'SOSPESA'
    | 'ANNULLATA'
    | 'DECADUTA'
    | 'RECESSO'
    | 'NOT_FOUND'
    | 'INSOLUTO'
    | 'PENDING'
    | 'DRAFT'
    | 'QUOTED';
  export const StatusEnum = {
    VALIDO: 'VALIDO' as StatusEnum,
    SCADUTO: 'SCADUTO' as StatusEnum,
    NONVALIDO: 'NON_VALIDO' as StatusEnum,
    SCADUTODECORRENZA: 'SCADUTO_DECORRENZA' as StatusEnum,
    DECORRENZAPOST60GIORNI: 'DECORRENZA_POST_60_GIORNI' as StatusEnum,
    NONVALIDOSELLA: 'NON_VALIDO_SELLA' as StatusEnum,
    APPENDICE: 'APPENDICE' as StatusEnum,
    ACQUISTATO: 'ACQUISTATO' as StatusEnum,
    SCADUTA: 'SCADUTA' as StatusEnum,
    ACQUISTATA: 'ACQUISTATA' as StatusEnum,
    ATTIVA: 'ATTIVA' as StatusEnum,
    CANCELLATA: 'CANCELLATA' as StatusEnum,
    SOSPESA: 'SOSPESA' as StatusEnum,
    ANNULLATA: 'ANNULLATA' as StatusEnum,
    DECADUTA: 'DECADUTA' as StatusEnum,
    RECESSO: 'RECESSO' as StatusEnum,
    NOTFOUND: 'NOT_FOUND' as StatusEnum,
    INSOLUTO: 'INSOLUTO' as StatusEnum,
    PENDING: 'PENDING' as StatusEnum,
    DRAFT: 'DRAFT' as StatusEnum,
    QUOTED: 'QUOTED' as StatusEnum,
  };
  export type MipEnum = 'post' | 'e_mail';
  export const MipEnum = {
    Post: 'post' as MipEnum,
    EMail: 'e_mail' as MipEnum,
  };
  export type ActionsEnum =
    | 'CLAIM'
    | 'CAR_REP'
    | 'REQUEST_ASSISTANCE'
    | 'CHANGE_ADDRESS'
    | 'CHANGE_MIP'
    | 'SUSPENSION'
    | 'REACTIVATION';
  export const ActionsEnum = {
    CLAIM: 'CLAIM' as ActionsEnum,
    CARREP: 'CAR_REP' as ActionsEnum,
    REQUESTASSISTANCE: 'REQUEST_ASSISTANCE' as ActionsEnum,
    CHANGEADDRESS: 'CHANGE_ADDRESS' as ActionsEnum,
    CHANGEMIP: 'CHANGE_MIP' as ActionsEnum,
    SUSPENSION: 'SUSPENSION' as ActionsEnum,
    REACTIVATION: 'REACTIVATION' as ActionsEnum,
  };
}
